export function formatModelPrice(price: string): string {
  const dollarsPerMillion = Number(price) * 1_000_000
  if (!Number.isFinite(dollarsPerMillion)) return '$-'
  if (dollarsPerMillion === 0) return '$0'
  return `$${dollarsPerMillion.toLocaleString('en-US', {maximumFractionDigits: 4})}`
}
